import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faCircleNotch = circleNotch('classic', 'thin');
export const falCircleNotch = circleNotch('classic', 'light');
export const fatCircleNotch = circleNotch('classic', 'thin');
export const fadCircleNotch = circleNotch('duotone', 'thin');
export const fasCircleNotch = circleNotch('classic', 'solid');
export const farCircleNotch = circleNotch('classic', 'regular');

export default function circleNotch(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'circle-notch',
    512, // width
    512, // height
    'f1ce', // unicode
    [
      [
        'classic',
        'solid',
        'M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z',
      ],
      [
        'classic',
        'regular',
        'M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z',
      ],
      [
        'classic',
        'light',
        'M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z',
      ],
      [
        'classic',
        'thin',
        'M199.7 14.3c1.1 4.3-1.4 8.7-5.7 9.8C91.5 51.4 16 144.9 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-111.1-75.5-204.6-178.1-231.9c-4.3-1.1-6.8-5.5-5.7-9.8s5.5-6.8 9.8-5.7C431.4 37.7 512 137.4 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 137.4 80.6 37.7 189.9 8.6c4.3-1.1 8.7 1.4 9.8 5.7z',
      ],
      [
        'duotone',
        'thin',
        [
          '',
          'M199.7 14.3c1.1 4.3-1.4 8.7-5.7 9.8C91.5 51.4 16 144.9 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-111.1-75.5-204.6-178.1-231.9c-4.3-1.1-6.8-5.5-5.7-9.8s5.5-6.8 9.8-5.7C431.4 37.7 512 137.4 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 137.4 80.6 37.7 189.9 8.6c4.3-1.1 8.7 1.4 9.8 5.7z',
        ],
      ],
    ]
  );
}
